<template>
  <div>
    <top-bar :back="true"/>
    <div class="w3-main" style="margin-top:50px;margin-left: 300px">
      <header class="w3-container w3-cell-row w3-margin-bottom w3-small" style="padding-top:22px">
        <button class="w3-button primary w3-right w3-round" @click="$router.push('/admin/pagamentos')">Pagamentos Pendentes</button>
        <h6><b>Buscar Vendas</b></h6>
      </header>
      <div class="w3-container">
        <div class="w3-row-padding w3-round w3-white w3-small" style="padding-bottom: 12px">
          <div class="w3-col l12 w3-margin-top">
            <label class="w3-margin-top"><b>Buscar Cliente</b></label>
            <input type="text" @keyup="pesquisar" class="w3-input w3-border" v-model="pesquisa" placeholder="Pesquisar por nome">
          </div>
        </div>
      </div>
      <div class="w3-container w3-margin-top">
        <div class="w3-white w3-responsive" style="margin-bottom: 80px">
          <table class="w3-table w3-bordered w3-centered w3-small">
            <tr class="primary">
              <th class="w3-left-align">Cliente</th>
              <th class="w3-left-align">Saldo</th>
              <th style="width: 120px">&nbsp;</th>
            </tr>
            <tr v-for="u in results" @click="$router.push('/admin/vendas/' + u.id_usuario)" v-show="pesquisa.trim() !== ''">
              <td>{{u.nome}}</td>
              <td class="w3-padding-16 w3-round-small w3-center w3-blue-gray" :class="{'w3-red' : u.valor > 0}">R$ {{parseFloat(u.valor * (-1)).toFixed(2)}}</td>
              <td><button class="w3-button w3-border">Vendas</button></td>
            </tr>
            <tr v-for="u in usuarios" @click="$router.push('/admin/vendas/' + u.id_usuario)" v-show="pesquisa.trim() === ''">
              <td>{{u.nome}}</td>
              <td class="w3-padding-16 w3-round-small w3-center w3-blue-gray" :class="{'w3-red' : u.valor > 0}">R$ {{parseFloat(u.valor * (-1)).toFixed(2)}}</td>
              <td><button class="w3-button w3-border">Vendas</button></td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"

  export default {
    components: {TopBar},

    data() {
      return {
        token: '',
        usuarios: [],
        pesquisa: '',
        results: [],
      }
    },

    methods: {
      buscarUsuarios() {
        openLoading("Buscando Usuarios");

        this.$http.get(base_url + 'usuarios/' + this.token)
          .then(response => {
            this.usuarios = response.data;
            closeLoading();

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result, res.data.msg, true);
          });
      },

      pesquisar() {
        let keys = [
          "nome",
          "email"
        ];

        let options = {
          shouldSort: true,
          threshold: 0.2,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: keys
        };

        this.$search(this.pesquisa, this.usuarios, options).then(results => {
          this.results = results;
        })
      },
    },

    mounted() {
      this.token = localStorage.getItem('key');
      this.buscarUsuarios();
    }
  }
</script>

<style scoped>
  .w3-table tr td {
    cursor: pointer;
    padding: 13px;
    text-align: left;
  }

  .w3-table td {
    vertical-align: middle;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/comanda/AdminComandas.vue